import { TRACKER_SUCCESS } from '@spp/tracking/lib/cjs/redux/actions/types';

/* eslint-disable import/prefer-default-export */
export const trackingReducer = (state = {}, action) => {
    if (action.type === TRACKER_SUCCESS) {
        return {
            ...state,
            [action.payload.trackerId]: true,
        };
    }

    return state;
};



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/tracking.js
 **/